import type { ReactNode } from "react";

/**
 * AS SEÇÕES DO SISTEMA COLABORADORES — nome, ícone e descrição num lugar só.
 *
 * A tela inicial (atalhos), a barra de baixo e o título de cada página leem
 * daqui. Com o nome escrito em três lugares, o primeiro ajuste de texto deixaria
 * o atalho dizendo uma coisa e o título outra.
 */

export type Secao =
  | "inicio"
  | "bater"
  | "espelho"
  | "folhas"
  | "extras"
  | "banco"
  | "documentos"
  | "dados";

const svg = (conteudo: ReactNode) => (
  <svg
    viewBox="0 0 24 24"
    width="22"
    height="22"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {conteudo}
  </svg>
);

export const ICONES: Record<Secao, ReactNode> = {
  inicio: svg(
    <>
      <path d="M3.5 10.5 12 4l8.5 6.5" />
      <path d="M5.5 9v10.5h13V9" />
      <path d="M10 19.5v-5h4v5" />
    </>,
  ),
  bater: svg(
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </>,
  ),
  espelho: svg(
    <>
      <rect x="3.5" y="4.5" width="17" height="16" rx="2.5" />
      <path d="M3.5 9h17M8 3v3M16 3v3" />
    </>,
  ),
  folhas: svg(
    <>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8Z" />
      <path d="M14 3v5h5M9 13l2 2 4-4" />
    </>,
  ),
  extras: svg(
    <>
      <circle cx="12" cy="13" r="8" />
      <path d="M12 9v4l2.5 1.5M9.5 2.5h5M12 12.9V13" />
    </>,
  ),
  banco: svg(
    <>
      <path d="M3.5 8.5h17v10a1.5 1.5 0 0 1-1.5 1.5H5a1.5 1.5 0 0 1-1.5-1.5v-10Z" />
      <path d="M3.5 8.5 12 3.5l8.5 5M16 14h2" />
    </>,
  ),
  documentos: svg(
    <>
      <path d="M3.5 7a2 2 0 0 1 2-2h4l2 2h7a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2Z" />
    </>,
  ),
  dados: svg(
    <>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <circle cx="9" cy="11" r="2.2" />
      <path d="M5.8 16c.6-1.6 1.8-2.4 3.2-2.4s2.6.8 3.2 2.4M14.5 10h4M14.5 13.5h3" />
    </>,
  ),
};

export const SECOES: { id: Secao; titulo: string; descricao: string; icone: ReactNode }[] = [
  { id: "inicio", titulo: "Início", descricao: "Resumo do seu dia", icone: ICONES.inicio },
  { id: "bater", titulo: "Bater ponto", descricao: "Entrada, almoço e saída", icone: ICONES.bater },
  { id: "espelho", titulo: "Meu mês", descricao: "Marcações dia a dia", icone: ICONES.espelho },
  { id: "folhas", titulo: "Folhas de ponto", descricao: "Meses fechados pelo DP", icone: ICONES.folhas },
  { id: "extras", titulo: "Horas extras", descricao: "Lançamentos e valores", icone: ICONES.extras },
  { id: "banco", titulo: "Banco de horas", descricao: "Saldo e extrato", icone: ICONES.banco },
  { id: "documentos", titulo: "Documentos", descricao: "Ver e enviar documentos", icone: ICONES.documentos },
  { id: "dados", titulo: "Meus dados", descricao: "Cadastro, conta, foto 3x4", icone: ICONES.dados },
];

export function tituloDe(secao: Secao): string {
  return SECOES.find((s) => s.id === secao)?.titulo ?? "";
}
